// export default SingleRendezVous;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AccountLayout from "../blocs/AccountLayout";
import useFetchRdv from "../components/useFetchRdv";
import Popup from "../components/Popup";
import {
  updateRendezVous,
  fetchInvoiceByRdvId,
} from "../store/slices/rendezVousSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  formatDuration,
  formatFrenchDate,
  formatMinutesToHourMinute,
  formattedDate,
  formatUpdateDate,
  isLessThan48h,
  lieuIntervention,
  StatusRdv,
  transformer,
} from "../utils/utils";
import SingleRendezVousSkeleton from "../components/skeletons/SingleRendezVousSkeleton";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { fr } from "date-fns/locale";


const SingleRendezVous = () => {
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupActionType, setPopupActionType] = useState(null); // 'delete' or 'edit'
  const [selectedRdvStartTime, setSelectedRdvStartTime] = useState(null);
  const [selectedRdvStatus, setSelectedRdvStatus] = useState(null);
  const [roleUser, setRoleUser] = useState(null);
  const locationIcons = lieuIntervention();
  const statusIcons = StatusRdv();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, currentRdv, currentRdvStatus, currentRdvError } = useFetchRdv();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (user && currentRdv && !selectedRdvStartTime) {
      setRoleUser(user.role);
      setSelectedRdvStartTime(currentRdv?.start_time);
    }
  }, [user, currentRdv, selectedRdvStartTime]);
  console.log("currentRdv", currentRdv);
  const handleEdit = (e) => {
    e.stopPropagation();
    if (currentRdv?.status === "enattente") {
      navigate(`/compte/rendez-vous/edit/${id}`);
    } else if (currentRdv?.status === "confirme") {
      if (isLessThan48h(currentRdv?.start_time)) {
        setSelectedRdvStartTime(currentRdv?.start_time);
        setSelectedRdvStatus(currentRdv?.status);
        setPopupActionType("edit");
        setPopupVisible(true);
      } else {
        navigate(`/compte/rendez-vous/edit/${id}`);
      }
    }
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setSelectedRdvStatus(currentRdv?.status);
    setSelectedRdvStartTime(currentRdv?.start_time);
    setPopupActionType("delete");
    setPopupVisible(true);
  };

  const handleDownloadClick = async (e) => {
    e.stopPropagation();
    try {
      const url = await dispatch(fetchInvoiceByRdvId(id)).unwrap();
      // console.log("URL reçue depuis le thunk :", url);
      if (url) window.open(url, "_blank");
    } catch (err) {
      // console.error("Erreur de récupération :", err);
      if (err?.status === 400 || err?.response?.status === 400) {
        toast.warning("La facture n'est pas encore disponible.");
      } else {
        toast.warning("Erreur lors du téléchargement de la facture.");
      }
    }
  };

  const handlePopupAction = () => {
    if (popupActionType === "delete") {
      const updatedRdv = { id, status: "annule" };
      dispatch(updateRendezVous(updatedRdv))
        .unwrap()
        .then(() => {
          setPopupVisible(false);
          setSelectedRdvStartTime(null);
          setSelectedRdvStatus(null);
          navigate("/compte/rendez-vous"); // Navigate back after cancellation
        })
        .catch((error) => {
          // console.error("Erreur lors de l'annulation:", error);
        });
    } else if (popupActionType === "edit") {
      setPopupVisible(false);
      navigate(`/compte/rendez-vous/edit/${id}`);
    }
  };

  function ttcDiscounted(prestationTtc, discountPercentage) {
    const price = prestationTtc * 1.055;
    const discountAmount = price * (discountPercentage / 100);
    const newTotal = price - discountAmount;
    return Number(newTotal.toFixed(2));
  }

  const ComponentReview = () => {
    const review = currentRdv?.reviews?.length ? currentRdv?.reviews[0] : null;
    if (!review) return null;
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <h4 className="mb-0">Avis client</h4>
            <img
              className="separator my-2"
              src="/images/separateur.svg"
              alt="séparateur"
            />
            <span className="body bold500">
              {currentRdv?.reviews[0]?.rating}
            </span>
            <img src="/images/star.svg" alt="Rating" style={{ width: 20 }} />
          </div>
        </div>
        <p className="body">{currentRdv?.reviews[0]?.comment}</p>
        <p className="body mt-2">{formattedDate(currentRdv?.start_time)}</p>
      </div>
    );
  };

  return (
    <AccountLayout
      linkBack="linkBack"
      review={roleUser === "prestataire"}
      childrenReview={
        roleUser === "prestataire" && currentRdv?.reviews?.length > 0 ? (
          <ComponentReview />
        ) : null
      }
    >
      {currentRdvStatus === "loading" ? (
        <SingleRendezVousSkeleton />
      ) : currentRdvError ? (
        <p className="body red">Erreur: {currentRdvError}</p>
      ) : (
        <div className="rendezvous-single main-content">
          <div className="rendezvous-header">
            <h2>
              Rendez-vous du{" "}
              {new Date(currentRdv?.start_time).toLocaleDateString("fr-FR")} à{" "}
              {new Date(currentRdv?.start_time).toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
                //  timeZone: "Europe/Paris",
              })}
            </h2>
            <div className="rendezvous-status">
              <img
                src={locationIcons[currentRdv?.lieu_intervention]}
                alt={currentRdv?.lieu_intervention}
              />
              <img
                src={statusIcons[currentRdv?.status]}
                alt={currentRdv?.status}
              />
            </div>
          </div>
          <div className="service-info">
            {currentRdv?.prestations_snapshot?.map((prestation, index) => (
              <div className="infos-pratiques" key={index}>
                <h4 className="paddingBt-16">{prestation?.name}</h4>
                <div className="infos-time-price">
                  <div className="infos-time">
                    <img src="/images/timer.svg" alt="Duration" />{" "}
                    {formatMinutesToHourMinute(prestation?.duree)},{" "}
                    {prestation?.nbr_seances} rendez-vous
                  </div>
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  {user?.role === "user" ? (
                    <div className="infos-price">
                      <img src="/images/coin.svg" alt="Price" />{" "}
                      {currentRdv?.total_ttc !== currentRdv?.amount_total &&
                      currentRdv?.amount_total !== null
                        ? `${ttcDiscounted(
                            prestation?.ttc,
                            currentRdv?.discount_percentage
                          )}€ TTC`
                        : `${(prestation?.ttc * 1.055).toFixed(2)}€ TTC`}
                    </div>
                  ) : (
                    <div className="infos-price">
                      <img src="/images/coin.svg" alt="Price" />{" "}
                      {prestation?.ttc}€ TTC
                    </div>
                  )}
                </div>
                {currentRdv?.lieu_intervention === "onsite" ? (
                  <div className="infos-location">
                    <span>
                      <img src="/images/location.svg" alt="Address" />
                      {currentRdv?.adresse_domicile}
                    </span>
                  </div>
                ) : currentRdv?.lieu_intervention === "chezpro" ? (
                  <div className="infos-location">
                    <span>
                      <img src="/images/location.svg" alt="Address" />
                      {currentRdv?.etablissement?.code_postal}{" "}
                      {currentRdv?.etablissement?.ville}{" "}
                      {currentRdv?.etablissement?.adresse_postale}
                    </span>
                  </div>
                ) : currentRdv?.lieu_intervention === "enligne" &&
                  currentRdv?.meeting_link ? (
                  <div className="video-conference">
                    <p className="body bold500 link">
                      Lien de la visioconférence
                    </p>
                    <a
                      href={currentRdv?.meeting_link}
                      className="video-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/link.svg" alt="Vidéoconférence" />
                      {currentRdv?.meeting_link}
                    </a>
                  </div>
                ) : (
                  <p className="body grey66">En ligne</p>
                )}
              </div>
            ))}
          </div>
          {currentRdv?.equipe_auto_assigned == false ? (
            <div className="mb-16">
              <h4 className="mrb-4">Préférence employé</h4>
              <div className="body grey66">{currentRdv?.equipe?.name}</div>
            </div>
          ) : (
            <></>
          )}
          {user?.role === "user" ? (
            <div className="professional-info">
              <h4 className="pd-bt-8">Prestataire</h4>
              <div className="professional-details">
                <span className="grey66">{currentRdv?.etablissement?.nom}</span>
                <img
                  className="separator"
                  src="/images/separateur.svg"
                  alt="separateur"
                />
                <span className="grey66">
                  {currentRdv?.etablissement?.activite?.name}
                </span>
                <img
                  className="separator"
                  src="/images/separateur.svg"
                  alt="separateur"
                />
                <p className="card-reviews body">
                  <img src="/images/star.svg" alt="Rating" />
                  {currentRdv?.average_rating}{" "}
                  <span className="card-reviews body">
                    ({currentRdv?.reviews_count} avis)
                  </span>
                </p>
              </div>
            </div>
          ) : (
            <div className="professional-info">
              <h4 className="pd-bt-8">Client</h4>
              <div className="mb-8">
                <img
                  className="mr-8"
                  src="/images/user-profile-gray.svg"
                  alt="user-profile"
                />
                <span className="body grey-light">
                  {currentRdv?.user?.prenom} {currentRdv?.user?.nom}
                </span>
              </div>
              <div className="d-flex">
                {currentRdv?.lieu_intervention === "onsite" ? (
                  currentRdv?.methode_contact === "telephone" ? (
                    <>
                      <img
                        src="/images/tel.svg"
                        alt="Téléphone"
                        className="me-2"
                      />
                      <span className="body grey-light">
                        {currentRdv?.contact_info}
                      </span>
                    </>
                  ) : currentRdv?.methode_contact === "email" ? (
                    <>
                      <img
                        src="/images/mail.svg"
                        alt="Email"
                        className="me-2"
                      />
                      <span className="body grey-light">
                        {currentRdv?.contact_info}
                      </span>
                    </>
                  ) : null
                ) : currentRdv?.lieu_intervention === "enligne" ? (
                  <span className="body grey-light">
                    {currentRdv?.user?.meeting_link}
                  </span>
                ) : currentRdv?.lieu_intervention === "chezpro" ? (
         
              <div>
                 {currentRdv?.user?.email&& (
                  <>
                <img src="/images/mail.svg" alt="mail" className="me-2" />
                  <span className="body grey-light">
                    {currentRdv?.user?.email}
                  </span>
                  </>

                 )} 
                  {currentRdv?.user?.email&&  currentRdv?.user?.phone_number &&(
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  )}
                  {currentRdv?.user?.phone_number&& (
                    <>
                                  <img src="/images/tel.svg" alt="Téléphone" className="me-2" />
                  <span className="body grey-light">
                    {currentRdv?.user?.phone_number}
                  </span>
                    </>
    
             
                  )}
                    </div> 
                ):null}

                {/* <div>
                  <img src="/images/mail.svg" alt="mail" className="me-2" />
                  <span className="body grey-light">
                    {currentRdv?.user?.email}
                  </span>
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  <img src="/images/tel.svg" alt="Téléphone" className="me-2" />
                  <span className="body grey-light">
                    {currentRdv?.user?.phone_number}
                  </span>
                </div> */}
              </div>
            </div>
          )}
          {user?.role === "user" ? (
            <div className="action-links">
              {currentRdv?.status === "passe" && (
                <>
                  <button
                    onClick={handleDownloadClick}
                    className="action-btn download"
                  >
                    <img
                      src="/images/download.svg"
                      alt="Télécharger la facture"
                    />
                    Télécharger ma facture
                  </button>

                  {currentRdv?.refunds?.[0]?.stripe_receipt_url && (
                    <>
                      <img
                        className="separator"
                        src="/images/separateur.svg"
                        alt="separateur"
                      />
                      <button
                        onClick={() => {
                          const url =
                            currentRdv?.refunds[0]?.stripe_receipt_url;
                          // console.log("here", url);
                          if (url) {
                            const link = document.createElement("a");
                            link.href = url;
                            link.target = "_blank";
                            link.rel = "noopener noreferrer"; // Bonne pratique de sécurité
                            document.body.appendChild(link); // Ajout au DOM
                            link.click(); // Déclenchement du clic
                            document.body.removeChild(link); // Nettoyage
                          }
                        }}
                        className="action-btn download"
                      >
                        <img
                          src="/images/download.svg"
                          alt="Télécharger la facture"
                        />
                        Facture d'avoir
                      </button>
                    </>
                  )}

                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  {currentRdv?.refund_requests?.length > 0 &&
                  currentRdv?.refund_requests[0]?.created_at ? (
                    <span className="link-blue">
                      Demande de remboursement envoyée le{" "}
                      {format(
                        new Date(currentRdv?.refund_requests[0]?.created_at),
                        "dd MMMM yyyy 'à' HH:mm",
                        {
                          locale: fr,
                        }
                      )}
                    </span>
                  ) : (
                    <button
                      onClick={() =>
                        navigate(
                          `/compte/demande-remboursement/${currentRdv?.id}`
                        )
                      }
                      className="action-btn reimbursement"
                    >
                      <img
                        src="/images/rembourse.svg"
                        alt="Demander un remboursement"
                      />
                      Demander le remboursement
                    </button>
                  )}

                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  {currentRdv?.has_pending_review === true ? (
                    <button
                      className="action-btn comment disabled"
                      disabled
                      aria-disabled="true"
                      tabIndex={-1}
                    >
                      <img
                        src="/images/comment.svg"
                        alt="Noter le prestataire"
                      />
                      Vous avez déjà noté ce professionnel
                    </button>
                  ) : (
                    <button
                      onClick={() =>
                        navigate(`/compte/review/${currentRdv?.id}`)
                      }
                      className="action-btn comment"
                    >
                      <img
                        src="/images/comment.svg"
                        alt="Noter le prestataire"
                      />
                      Noter le prestataire
                    </button>
                  )}
                </>
              )}
              {currentRdv?.status === "annule" && (
                <>
                  {currentRdv?.refunds?.[0]?.stripe_receipt_url && (
                    <button
                      onClick={() => {
                        const url = currentRdv?.refunds[0]?.stripe_receipt_url;
                        // console.log("here", url);
                        if (url) {
                          const link = document.createElement("a");
                          link.href = url;
                          link.target = "_blank";
                          link.rel = "noopener noreferrer";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }
                      }}
                      className="action-btn download"
                    >
                      <img
                        src="/images/download.svg"
                        alt="Télécharger la facture"
                      />
                      Facture d'avoir
                    </button>
                  )}
                </>
              )}
              {currentRdv?.status === "confirme" && (
                <>
                  <button
                    onClick={handleDownloadClick}
                    className="action-btn download"
                  >
                    <img
                      src="/images/download.svg"
                      alt="Télécharger la facture"
                    />
                    Télécharger ma facture
                  </button>
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  <button onClick={handleEdit} className="action-btn modify">
                    <img src="/images/edit.svg" alt="Modifier" />
                    Modifier mon rendez-vous
                  </button>
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  <button
                    onClick={handleDeleteClick}
                    className="action-btn delete redLink"
                  >
                    Annuler le rendez-vous
                  </button>
                </>
              )}
              {currentRdv?.status === "enattente" && (
                <>
                  <button onClick={handleEdit} className="action-btn modify">
                    <img src="/images/edit.svg" alt="Modifier" />
                    Modifier mon rendez-vous
                  </button>
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  <button
                    onClick={handleDeleteClick}
                    className="action-btn delete redLink"
                  >
                    Annuler le rendez-vous
                  </button>
                </>
              )}
            </div>
          ) : null}
        </div>
      )}
      {isPopupVisible && (
        <Popup
          isOpen={isPopupVisible}
          onClose={() => {
            setPopupVisible(false);
            setSelectedRdvStartTime(null);
            setSelectedRdvStatus(null);
          }}
          onAction={handlePopupAction}
          title={
            popupActionType === "edit"
              ? "Modification impossible à ce stade"
              : isLessThan48h(selectedRdvStartTime) &&
                selectedRdvStatus === "confirme"
              ? "Information importante concernant votre annulation"
              : "Annuler le rendez-vous"
          }
          text={
            popupActionType === "delete" ? (
              selectedRdvStatus === "enattente" ? (
                <p className="body">
                  Votre demande est toujours en attente de confirmation par le
                  prestataire.
                  <br />
                  Conformément à nos conditions, vous êtes éligible à un
                  remboursement. Nous procéderons à l’annulation de votre
                  réservation.
                </p>
              ) : selectedRdvStatus === "confirme" &&
                isLessThan48h(selectedRdvStartTime) ? (
                <p className="body">
                  Votre réservation commence dans moins de 48 heures. <br />
                  Toute annulation à ce stade n’est pas remboursable, comme
                  indiqué dans nos conditions. <br />
                  Nous restons disponibles pour toute question.
                </p>
              ) : selectedRdvStatus === "confirme" ? (
                <p className="body">
                  Votre demande concerne une réservation prévue dans plus de 48
                  heures. <br />
                  Conformément à nos conditions, vous êtes éligible à un
                  remboursement partiel. <br />
                  Nous procéderons à l’annulation de votre réservation.
                </p>
              ) : (
                <p className="body">
                  Statut inconnu. Veuillez contacter le support.
                </p>
              )
            ) : (
              <p className="body">
                Conformément à nos conditions, les modifications de date ou
                d’horaire ne sont plus possibles dans ce délai. Si vous avez une
                urgence, n’hésitez pas à nous contacter – nous ferons de notre
                mieux pour vous accompagner.
              </p>
            )
          }
          actionButtonText={
            popupActionType === "edit" && isLessThan48h(selectedRdvStartTime)
              ? undefined
              : popupActionType === "edit"
              ? "Modifier le rendez-vous"
              : "Annuler mon rendez-vous"
          }
          closeButtonText="Revenir"
          closeButtonClassName="bold600"
          color="blue"
          icon={
            <svg
              width="88"
              height="88"
              viewBox="0 0 88 88"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="88"
                height="88"
                rx="14.6667"
                fill="#DD1E03"
                fillOpacity="0.1"
              />
              <path
                d="M44.4001 44.4001V34.5001M44.4001 51.7381V51.8251M64.2001 44.4001C64.2001 55.3353 55.3353 64.2001 44.4001 64.2001C33.4649 64.2001 24.6001 55.3353 24.6001 44.4001C24.6001 33.4649 33.4649 24.6001 44.4001 24.6001C55.3353 24.6001 64.2001 33.4649 64.2001 44.4001Z"
                stroke="#DD1E03"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
        />
      )}
    </AccountLayout>
  );
};

export default SingleRendezVous;
